import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@app/kernel/translations/resolvers/load-translations.resolver";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";

export const assetsRoutes: Routes = [
  {
    path: "car-asset-types",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.CAR_ASSET_TYPES]),
    },
    loadChildren: () => import("./domains/car-asset-types/car-asset-types.routes").then(r => r.carAssetTypesRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.CAR_ASSET_TYPE.VIEW },
  },
  {
    path: "car-assets",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.CAR_ASSET_TYPES, TRANSLATION_PATHS.ASSETS.CAR_ASSETS]),
    },
    loadChildren: () => import("./domains/car-assets/car-assets.routes").then(r => r.carAssetsRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.CAR_ASSET.VIEW },
  },
  {
    path: "fuel-cards",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.FUEL_CARDS]),
    },
    loadChildren: () => import("./domains/fuel-cards/fuel-cards.routes").then(r => r.fuelCardsRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.FUEL_CARD.VIEW },
  },
  {
    path: "consumable-materials",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.CONSUMABLE_MATERIALS]),
    },
    loadChildren: () => import("./domains/consumable-materials/consumable-materials.routes").then(r => r.consumableMaterialsRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.CONSUMABLE_MATERIAL.VIEW },
  },
  {
    path: "pos-devices",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.POS_DEVICES]),
    },
    loadChildren: () => import("./domains/pos-devices/pos-devices.routes").then(r => r.posDevicesRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.POS_DEVICE.VIEW },
  },
  {
    path: "document-scanners",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.DOCUMENT_SCANNERS]),
    },
    loadChildren: () => import("./domains/document-scanners/document-scanners.routes").then(r => r.documentScannersRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.DOCUMENT_SCANNER.VIEW },
  },
  {
    path: "device-tags",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.DEVICE_TAGS]),
    },
    loadChildren: () => import("./domains/device-tags/device-tags.routes").then(r => r.deviceTagsRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.DEVICE_TAG.VIEW },
  },
  {
    path: "devices",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.DEVICES]),
    },
    loadChildren: () => import("./domains/devices/devices.routes").then(r => r.devicesRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.DEVICE.VIEW },
  },
  {
    path: "sim-cards",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.SIM_CARDS]),
    },
    loadChildren: () => import("./domains/sim-cards/sim-cards.routes").then(r => r.simCardsRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.SIM_CARD.VIEW },
  },
  {
    path: "signature-licenses",
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.ASSETS.SIGNATURE_LICENSES]),
    },
    loadChildren: () => import("./domains/signature-licenses/signature-licenses.routes").then(r => r.signatureLicensesRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.SIGNATURE_LICENSE.VIEW },
  },
];
